<mat-spinner [diameter]="diameter || 15" [ngClass]="{'white': white}"></mat-spinner>
